let _ = require('lodash');

module.exports = {
    getUser ({ userId }, state, output, { locator, context }) {
        let API = locator.resolve('api');

        let request = API.getUserById(context, locator, { userId });

        request
            .then((data) => {
                let code = _.get(data, 'status.code');

                if (code === 200) {
                    let user = _.get(data, 'content');
                    output.success({ user });
                    return;
                }

                output.error({ error: code });
            })
            .catch((error) => output.error({ error }));
    }
};



// WEBPACK FOOTER //
// ./actions/account/users.js